export default __webpack_public_path__ + "static/media/7minfitness@3x.cf388f87.jpg";